'use client'

// The strip's own auto glyph, so the board's door into the sheet and the
// button it stands in for are the same mark.
import SyncIcon from 'src/app/assets/icons/ico-sync-alt.svg'
import { birdieAutoBetCopy } from './autoBetCopy'
import type { Translate } from './tileViewModel'

type Props = Readonly<{
  onOpen: () => void
  t: Translate
}>

/**
 * The way into the auto-bet sheet while the strip is gone (owner 2026-09-17).
 *
 * The strip hides with the tiles, and its auto button goes with it — so from
 * the moment betting closes there was no way in at all, even though the rule
 * is perfectly happy to be armed early: it only ever plans an open, priced
 * round, so arming here places nothing until the next one opens. A player who
 * sat this round out can now set the rule up while it runs.
 *
 * The armed pill's quiet sibling, in the pill's own row: the same capsule, the
 * glyph where the live dot goes, one label — and no cross, because there is no
 * rule yet to stop. The host decides when it is on screen
 * (`autoBetEntryVisible`); it is never up at the same time as the strip.
 */
export function BirdieAutoBetOpener({ onOpen, t }: Props) {
  const copy = birdieAutoBetCopy(t)

  return (
    <div className="birdie-autobet-pill birdie-autobet-pill--opener">
      <button className="birdie-autobet-pill__open" onClick={onOpen} type="button">
        <SyncIcon aria-hidden="true" className="birdie-autobet-pill__glyph" />
        <span className="birdie-autobet-pill__part">{copy.setUp}</span>
      </button>
    </div>
  )
}
